<template>
  <PageTable :orderCode="orderCode" :disabled="disabled" />
</template>
<script>
import PageTable from './components/table'
export default {
  components: { PageTable },
  props: {
    orderCode: String,
    disabled: { type: Boolean, default: false },
  },
}
</script>
